module.exports = __webpack_public_path__ + "static/media/parakeet-app.3888ab9a.png";